'use es6';

import styled from 'foundations-theming/utils';
import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { SaveBarContainer } from 'customer-data-properties/savebar/SaveBarContainer';
import { universalEditableAreas } from 'customer-data-properties/savebar/EditableAreas';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { ButtonWrapper } from 'foundations-components/transitional/components/ButtonWrapper';
import { EARTH_LAYER } from 'foundations-components/transitional/constants';
import { PanelFooter } from 'foundations-components/transitional/components/PanelFooter';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StickyFooterWrapper = styled.div.withConfig({
  displayName: "UniversalSidebarFooter__StickyFooterWrapper",
  componentId: "wg5un4-0"
})(["position:sticky;bottom:0;left:0;right:0;z-index:", ";"], EARTH_LAYER);
export const UniversalSidebarFooter = ({
  formattedChanges,
  hasErrors,
  handleSave,
  handleCancel,
  hasChanges
}) => {
  return /*#__PURE__*/_jsx(StickyFooterWrapper, {
    "data-selenium-test": "preview-footer-refactor",
    "data-test-id": "universal-sidebar-footer",
    children: /*#__PURE__*/_jsxs(PanelFooter, {
      children: [/*#__PURE__*/_jsx(TruncateString, {
        paddingBlock: "300",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: "customerDataSidebar.boundedSaveBar.info",
          options: {
            changes: formattedChanges
          }
        })
      }), /*#__PURE__*/_jsxs(ButtonWrapper, {
        paddingBlockEnd: "500",
        children: [/*#__PURE__*/_jsx(Button, {
          disabled: hasErrors || !hasChanges,
          onClick: handleSave,
          "data-selenium-test": "PreviewSaveBar-button-primary",
          "data-test-id": "universal-sidebar-save-button",
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "customerDataSidebar.boundedSaveBar.saveButtonText"
          })
        }), /*#__PURE__*/_jsx(Button, {
          disabled: !hasChanges,
          "data-selenium-test": "PreviewSaveBar-button",
          "data-test-id": "universal-sidebar-cancel-button",
          onClick: handleCancel,
          children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
            message: "customerDataSidebar.boundedSaveBar.cancelButtonText"
          })
        })]
      })]
    })
  });
};
UniversalSidebarFooter.propTypes = {
  formattedChanges: PropTypes.string,
  handleCancel: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  hasChanges: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired
};
const ConnectedUniversalSidebarFooter = SaveBarContainer(UniversalSidebarFooter, universalEditableAreas);
export default ConnectedUniversalSidebarFooter;